import React, { useEffect, useState } from "react";
import Head from "../../../layout/head/Head";
import { useLocation, useNavigate } from "react-router";
import { useFieldArray, useForm } from "react-hook-form";
import Content from "../../../layout/content/Content";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  Icon,
  PreviewAltCard,
  Row,
} from "../../../components/Component";
import { StepHeader } from "./StepHeader";
import { Form } from "reactstrap";
import Required from "../../../MyComp/UI/form/Required";
import MySelect from "../../../MyComp/UI/form/MySelect";
import MyInput from "../../../MyComp/UI/form/MyInput";
import MyDate from "../../../MyComp/UI/form/MyDate";
import moment from "moment";
import ImageUpload from "../../../MyComp/UI/form/ImageUpload";
import MyCreateSelect from "../../../MyComp/UI/form/MyCreateSelect";
import MyCheck from "../../../MyComp/UI/form/MyCheck";
import MyTextArea from "../../../MyComp/UI/form/MyTextArea";
import { listQualificationDDAPI, listSpecificationDDAPI } from "../../../api/dropdown";
import { toast } from "react-toastify";
import useLogout from "../../../hooks/useLogout";
import MyButton from "../../../MyComp/UI/form/MyButton";
import { doctorQualificationRegistration } from "../../../api/doctor";

const StepTwo = () => {
  const location = useLocation();
  const { logout } = useLogout();
  const navigate = useNavigate();
  const [hasExperience, setHasExperience] = useState(false);
  const [totalExperienceDays, setTotalExperienceDays] = useState(0);


  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    clearErrors,
    reset,
    setError,
    getValues,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      experience: false,
      experiences: [],

      isLoading: false,
      agreed: false,
      medical_qualification: null,
      qualificationDD: [],
      specializationDD: [],

      pan_image: null,
      pan_img: null,

      cert_image: null,
      cert_img: null,

      objectionKeys: [],
      approvedKeys: [],

      degree: [
        {
          certificate: null,
          certificate_url: null,
        },
      ],
      qualifications: [
        {
          degree_name: "",
          institution_name: "",
          year_of_passing: null,
        },
      ],
      experiences: [
        {
          organization: "",
          from_date: null,
          to_date: null,
          department_id: "",
          is_current: false,
          description: "",
        },
      ],
      mode: location?.state?.mode || "Add",
      actionType: null,
    },
  });
  const { fields, append, remove } = useFieldArray({
    control,
    name: "degree",
  });
  const doctorId = location?.state?.doctorId || null;

  const {
    fields: experienceFields,
    append: appendExperience,
    remove: removeExperience,
  } = useFieldArray({
    control,
    name: "experiences",
  });
  const {
    fields: qualificationFields,
    append: appendQualification,
    remove: removeQualification,
  } = useFieldArray({
    control,
    name: "qualifications",
  });
  const [mode, setMode] = useState(location?.state?.mode || "Add");
  const isLoading = watch("isLoading");
  const [imageOpen, setImageOpen] = useState(false);
  const handleImageOpenPreview = (row) => {
    const imageUrl = `${row?.image}`;
    setValue("image_preview", imageUrl);
    setImageOpen(true);
  };
  const getQualification = () => {
    listQualificationDDAPI({})
      .then((res) => {
        console.log("log", res.data.data);

        //const status = decrypt(res.data.status);
        if (res.data.status === true) {
          toast.clearWaitingQueue();
          setValue("qualificationDD", res.data.data);
          setValue("isLoading", false);
        } else if (res.data.status === false) {
          setValue("isLoading", false);
          setValue("qualificationDD", []);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") {
          console.log("token expired", res.data);
          setValue("isLoading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        setValue("isLoading", false);
        toast.error(err?.response?.data?.message);
      });
  };
  const getSpecialization = (body) => {
    listSpecificationDDAPI(body)
      .then((res) => {
        //const status = decrypt(res.data.status);
        if (res.data.status === true) {
          toast.clearWaitingQueue();
          setValue("specializationDD", res.data.data);
          setValue("isLoading", false);
        } else if (res.data.status === false) {
          setValue("isLoading", false);
          setValue("specializationDD", []);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") {
          setValue("isLoading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        setValue("isLoading", false);
        toast.error(err?.response?.data?.message);
      });
  };
  useEffect(() => {
    getQualification();
    getSpecialization();
  }, []);

 const calculateTotalExperienceDays = () => {
  const experiences = watch("experiences") || [];
  let totalDays = 0;

  experiences.forEach((exp) => {
    if (exp?.from_date) {
      const from = moment(exp.from_date);

      const to = exp?.is_current
        ? moment()
        : exp?.to_date
          ? moment(exp.to_date)
          : null;

      if (to && to.isAfter(from)) {
        totalDays += to.diff(from, "days");
      }
    }
  });

  return totalDays;
};

  const years = (calculateTotalExperienceDays() / 365).toFixed(1);

  // console.log(years,"formatExperience");

  const onFormSubmit = (data) => {
    console.log(data, "data")
    const formData = new FormData();
    formData.append(
      "medical_council_registration_no",
      data.medical_council_registration_number || ""
    );
    const certImg = watch("cert_img");
    if (certImg instanceof File) {
      formData.append("cert_img", certImg);
    } else if (typeof certImg === "string") {
      formData.append("cert_img", certImg);
    }
    formData.append(
      "language",
      watch("known_language")?.map((item) => item.value)
    );

    formData.append(
      "experience",
      watch("experience") ? (calculateTotalExperienceDays() / 365).toFixed(1) : 0
    );


    if (watch("specialization")?.length > 0) {
      formData.append(
        "specialization",
        watch("specialization")?.map((item) => item.value)
      );
    } else {
      formData.append("specialization", watch("specialization").value);
    }

    formData.append("doctorId", doctorId);
    data?.degree?.forEach((item, index) => {
      formData.append(`degree[${index}].certificate`, item.certificate || "");
    });
    data?.qualifications?.forEach((item, index) => {
      formData.append(`qualifications[${index}].degree`, item?.degree_name?.label || "");
      formData.append(`qualifications[${index}].institute`, item?.university_name || "");
      formData.append(`qualifications[${index}].yearCompletion`, moment(item?.from_date).format("YYYY-MM-DD") || null);
    });

    if (watch("experience")) {
      data?.experiences?.forEach((item, index) => {
        formData.append(`experiences[${index}].organization`, item.organization || "");
        formData.append(`experiences[${index}].position`, item.department || "");
        formData.append(
          `experiences[${index}].startDate`,
          item.from_date ? moment(item.from_date).format("YYYY-MM-DD") : null
        );
        formData.append(
          `experiences[${index}].endDate`,
          item.is_current
            ? null
            : item.to_date
              ? moment(item.to_date).format("YYYY-MM-DD")
              : null
        );
        formData.append(`experiences[${index}].isPresent`, item.is_current ? 1 : 0);
        formData.append(`experiences[${index}].description`, item.description || "");
      });
    }


    if (mode == "Add") {
      doctorQualificationRegistration(formData).then((res) => {
        if (res.data.status === true) {
          navigate("/doctor-registration/slot-management-and-availability", {
            state: { mode: "Add", doctorId: res.data.data?.doctorId },
          });
          toast.success(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === false) {
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") {
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      });
    }
    console.log("Data", data);
  };



  const formatExperience = (days) => {
    const years = Math.floor(days / 365);
    const months = Math.floor((days % 365) / 30);

    if (years > 0) {
      return `${years} year  ${months} months`;
    }
    return `${months} months`;
  };


  useEffect(() => {
    if (watch("experience") && experienceFields.length === 0) {
      appendExperience({
        organization: "",
        from_date: null,
        to_date: null,
        department_id: "",
        is_current: false,
      });
    }
  }, [watch("experience")]);


  return (
    <>
      <Head title={"Doctor Registration | Professional Details"} />
      <Content>
        <BlockHead size={"sm"}>
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page tag="h3">
                {"Doctor Registration"}
              </BlockTitle>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        <Block>
          <PreviewAltCard>
            <StepHeader current={2} />
            <Form onSubmit={handleSubmit(onFormSubmit)}>
              <Row className=" ">
                <div className="my-div mt-2 ">
                  <BlockTitle tag="h6">{"Professional Qualification"}</BlockTitle>
                  <hr />
                  <table className="table table-bordered table-scroll mt-3" id="productTable">
                    <thead>
                      <tr>
                        <th scope="col ">
                          Degree/Qualification
                          <Required />
                        </th>
                        <th scope="col ">
                          University/Institution Name
                          <Required />
                        </th>
                        <th scope="col ">
                          Year of Completion
                          <Required />
                        </th>

                        <th scope="col">
                          <Button
                            type="button"
                            color="primary"
                            outline
                            size={"xs"}
                            className={`  me-n1`}
                            id="addProduct"
                            onClick={() =>
                              appendQualification({
                                degree_name: "",
                                institution_name: "",
                                year_of_passing: null,
                              })
                            }
                          >
                            <Icon name="plus"></Icon>
                          </Button>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {qualificationFields.map((field, index) => (
                        <tr key={field.id}>
                          <td>
                            <MySelect
                              register={register}
                              watch={watch}
                              setValue={setValue}
                              trigger={trigger}
                              errors={errors}
                              name={`qualifications.${index}.degree_name`}
                              placeholder={"Select degree"}
                              required
                              options={watch("qualificationDD")}
                              disabled={mode == "Approval"}
                            />
                          </td>
                          <td>
                            <MyInput
                              register={register}
                              watch={watch}
                              setValue={setValue}
                              trigger={trigger}
                              errors={errors}
                              name={`qualifications.${index}.university_name`}
                              placeholder={"Enter university name"}
                              required
                              min={3}
                              max={50}
                              disabled={mode == "Approval"}
                            />
                          </td>

                          <td>
                            <MyDate
                              register={register}
                              watch={watch}
                              setValue={setValue}
                              trigger={trigger}
                              errors={errors}
                              name={`qualifications.${index}.from_date`}
                              placeholder={"Choose year"}
                              required
                              max={moment().subtract(0, "years").toDate()}
                              min={moment().subtract(90, "years").toDate()}
                              disabled={mode == "Approval"}
                              year
                            />
                          </td>

                          <td>
                            {index === 0 ? null : (
                              <Button
                                type="button"
                                color="danger"
                                size="xs"
                                outline
                                onClick={() => removeQualification(index)}
                              >
                                <Icon name="trash" />
                              </Button>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <h5 className="my-3">{"Professional Details"}</h5>

                <Col md="3" className={``}>
                  <MySelect
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Specialization"}
                    name={"specialization"}
                    placeholder={"Select specialization"}
                    required
                    options={watch("specializationDD")}
                    multi
                    disabled={mode == "Approval"}
                  />
                </Col>
                <Col md="3" className={``}>
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Medical Council Registration No"}
                    // name={"registration"}
                    name={"medical_council_registration_number"}
                    placeholder={"Enter registration number"}
                    required
                    min={5}
                    max={15}
                    disabled={mode == "Approval"}
                  />
                </Col>

                <Col md="3">
                  <ImageUpload
                    getValues={getValues}
                    id="cert_image"
                    watch={watch}
                    trigger={trigger}
                    setError={setError}
                    clearErrors={clearErrors}
                    label={"Medical Council Registration Certificate"}
                    errors={errors}
                    register={register}
                    image={"cert_img"}
                    image_url={"cert_image"}
                    setValue={setValue}
                    handleImageOpenPreview={handleImageOpenPreview}
                    required
                    validateDoc
                    approve={mode === "Approval" ? true : false}
                    size={2048}
                  />
                </Col>
                <Col md="3" className={``}>
                  <MyCreateSelect
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Languages Known"}
                    name={"known_language"}
                    placeholder={"specify known languages"}
                    required
                    multi
                    disabled={mode == "Approval"}
                  />
                </Col>

                {fields.map((field, index) => (
                  <>
                    <Col md="3" key={field.id}>
                      {" "}
                      <ImageUpload
                        getValues={getValues}
                        id={`certificate_image_${index}`}
                        watch={watch}
                        trigger={trigger}
                        setError={setError}
                        clearErrors={clearErrors}
                        errors={errors}
                        register={register}
                        label={`Degree Certificate ${index + 1}`}
                        image={`degree.${index}.certificate`}
                        image_url={`degree.${index}.certificate_url`}
                        setValue={setValue}
                        handleImageOpenPreview={handleImageOpenPreview}
                        required
                        validateDoc
                        rm
                        index={index}
                        remove={remove}
                        approve={mode === "Approval" ? true : false}
                        size={2048}
                      />
                    </Col>
                  </>
                ))}

                {(watch("mode") === "Add" || watch("mode") === "Edit") && (
                  <Col md="2">
                    <Button
                      style={{ marginTop: "30px" }}
                      type="button"
                      color="primary"
                      className=" "
                      id="addDegree"
                      onClick={() => {
                        append({ certificate: null, certificate_url: null });
                      }}
                    >
                      {"Add Degree"}
                    </Button>{" "}
                  </Col>
                )}


                <div className="my-div mt-4">
                  <label className="d-flex align-items-center gap-2">
                    <input
                      type="checkbox"
                      {...register("experience")}
                      onChange={(e) => {
                        setValue("experience", e.target.checked);
                        if (!e.target.checked) {
                          setValue("experiences", []);
                        }
                      }}
                    />
                    <BlockTitle tag="h6" className="mb-0">
                      {"Professional Experiences"}
                      {calculateTotalExperienceDays() > 0 && (
                        <span className="text-muted ms-2 fs-12">
                          ({formatExperience(calculateTotalExperienceDays())})
                        </span>
                      )}
                    </BlockTitle>
                  </label>
                </div>


                {watch("experience") && (
                  <div className="my-div mt-2 ">

                    <hr />

                    <table className="table table-bordered table-scroll mt-3" id="productTable">
                      <thead>
                        <tr>
                          <th scope="col ">
                            Organization
                            <Required />
                          </th>
                          <th scope="col ">
                            Department
                            <Required />
                          </th>
                          <th scope="col ">
                            From Date
                            <Required />
                          </th>
                          <th scope="col">
                            To Date
                            <Required />
                          </th>
                          <th scope="col">Description</th>
                          <th scope="col">
                            <Button
                              type="button"
                              color="primary"
                              outline
                              size={"xs"}
                              className={`  me-n1`}
                              id="addProduct"
                              onClick={() =>
                                appendExperience({
                                  organization: "",
                                  from_date: null,
                                  to_date: null,
                                  department_id: "",
                                  is_current: false,
                                })
                              }
                            >
                              <Icon name="plus"></Icon>
                            </Button>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {experienceFields.map((field, index) => (
                          <tr key={field.id}>
                            <td>
                              <MyInput
                                register={register}
                                watch={watch}
                                setValue={setValue}
                                trigger={trigger}
                                errors={errors}
                                name={`experiences.${index}.organization`}
                                placeholder={"Enter organization name"}
                                required
                                min={3}
                                max={50}
                                disabled={mode == "Approval"}
                              />
                            </td>
                            <td>
                              <MyInput
                                register={register}
                                watch={watch}
                                setValue={setValue}
                                trigger={trigger}
                                errors={errors}
                                name={`experiences.${index}.department`}
                                placeholder={"Enter department name"}
                                required
                                min={3}
                                max={50}
                                disabled={mode == "Approval"}
                              />
                            </td>

                            <td>
                              <MyDate
                                register={register}
                                watch={watch}
                                setValue={setValue}
                                trigger={trigger}
                                errors={errors}
                                name={`experiences.${index}.from_date`}
                                placeholder={"Enter from date"}
                                required
                                max={moment().subtract(0, "years").toDate()}
                                min={moment().subtract(90, "years").toDate()}
                                disabled={mode == "Approval"}
                              />
                            </td>
                            <td>
                              <div className="d-flex flex-wrap">
                                {" "}
                                <MyCheck
                                  register={register}
                                  watch={watch}
                                  setValue={setValue}
                                  trigger={trigger}
                                  errors={errors}
                                  name={`experiences.${index}.is_current`}
                                  placeholder={"Current"}
                                  disabled={mode == "Approval"}
                                />
                                {!watch(`experiences.${index}.is_current`) && (
                                  <MyDate
                                    register={register}
                                    watch={watch}
                                    setValue={setValue}
                                    trigger={trigger}
                                    errors={errors}
                                    name={`experiences.${index}.to_date`}
                                    placeholder={"Enter To Date"}
                                    max={moment().toDate()}
                                    min={moment().subtract(90, "years").toDate()}
                                    disabled={mode == "Approval"}
                                    required={mode == "Approval"}
                                  />
                                )}
                              </div>
                            </td>
                            <td className="w-25">
                              <MyTextArea
                                register={register}
                                watch={watch}
                                setValue={setValue}
                                trigger={trigger}
                                errors={errors}
                                name={`experiences.${index}.description`}
                                placeholder={"Brief description of your role and responsibilities"}
                                // min={25} 
                                max={500}
                                cols={2}
                                row={1}

                                disabled={mode == "Approval"}
                              />
                            </td>

                            <td>
                              {index === 0 ? null : (
                                <Button
                                  type="button"
                                  color="danger"
                                  size="xs"
                                  outline
                                  onClick={() => removeExperience(index)}
                                >
                                  <Icon name="trash" />
                                </Button>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>

                  </div>
                )}

              </Row>
              {(mode == "Add" || mode == "Edit") && (
                <Row>
                  <Col md="12" className={``}>
                    <div className="form-group d-flex justify-content-end" style={{ marginTop: "31px" }}>
                      <MyButton isLoading={isLoading} mode={mode} />
                    </div>
                  </Col>
                </Row>
              )}
            </Form>
          </PreviewAltCard>
        </Block>
      </Content >
    </>
  );
};

export default StepTwo;
